import { jsx as _jsx } from "react/jsx-runtime";
import ExpandMoreRoundedIcon_ from "@mui/icons-material/ExpandMoreRounded.js";
import { styled } from "@mui/material";
import { normalizeIcon } from "./helpers/normalizeIcon.js";
const ExpandMoreRoundedIcon = normalizeIcon(ExpandMoreRoundedIcon_);
const StyledExpandIcon = styled(ExpandMoreRoundedIcon)(({ theme, expanded }) => ({
    transform: `rotate(${expanded ? 180 : 0}deg)`,
    transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.short,
    }),
}));
const ExpandIcon = ({ expanded = false, sx = {} }) => (_jsx(StyledExpandIcon, { expanded: expanded, sx: sx }));
export default ExpandIcon;
